'use client';

import AppLogo from '@/assets/logos/app/light.svg';
import { useLingui } from '@lingui/react';
import { Button } from '@prismo-io/design-system';
import { Application, translate } from '@prismo-io/router';
import { LanguageCode, type LanguageCodeT } from '@prismo-io/schemas';
import Image from 'next/image';
import Link from 'next/link';
type Props = {
  userUrl: string;
};
const buildAppUrl = (locale: LanguageCodeT, userUrl: string) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.APP,
    path: `/`,
    // path: `/profil/:user`,
    // params: { user: userUrl },
    locale
  });
};
export const LogoBtn = (props: Props) => {
  const {
    userUrl
  } = props;
  const {
    i18n
  } = useLingui();
  const {
    locale = LanguageCode.Enum.fr
  } = i18n;
  const appUrl = buildAppUrl(locale as LanguageCodeT, userUrl);
  return <Button variant="text" LinkComponent={Link} href={appUrl} sx={{
    padding: 0
  }} data-sentry-element="Button" data-sentry-component="LogoBtn" data-sentry-source-file="index.tsx">
      <Image src={AppLogo} alt="Logo de PRISMO App" height={16} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </Button>;
};